import React from "react";
import LandingPageLayout from "@/components/LandingPageLayout";

export default function HourlyChauffeur() {
  return (
    <LandingPageLayout translationKey="hourlyChauffeur" />
  );
}
